import { useEffect } from 'react'
import { connect } from 'react-redux'
import { removeError } from 'portal-modules/common/redux/modules/errors'
import PropTypes from 'prop-types'

const RemoveErrorsOnUnmount = ({ errorKey, removeError, children, isfromRPOneTapPay, isPlaidSelected }) => {
  errorKey = errorKey?.split(',')
  useEffect(() => 
    () => {
      if(isfromRPOneTapPay && isPlaidSelected) return false
        errorKey.map(err => removeError(err))
    }
  ,[])
  return children
}

RemoveErrorsOnUnmount.prototypes = {
  isfromRPOneTapPay: PropTypes.bool,
  isPlaidSelected: PropTypes.bool,
  removeError: PropTypes.func,
  errorKey: PropTypes.string,
}

RemoveErrorsOnUnmount.defaultProps = {
  isfromRPOneTapPay: false,
  isPlaidSelected: false,
  removeError: () => {},
  errorKey: '',
}

export default connect(
  (state, ownProps) => ownProps,
  { removeError },
)(RemoveErrorsOnUnmount)
